var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var DelayedRefresh = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M11.9999 7.5V12L15.8999 14.25M17.2686 9.34688H21.0186M21.0186 9.34688V5.59688M21.0186 9.34688L17.8311 6.16875C16.6776 5.0143 15.2076 4.22789 13.6071 3.90902C12.0066 3.59014 10.3474 3.75313 8.83953 4.37735C7.33165 5.00158 6.04278 6.059 5.13596 7.41585C4.22914 8.7727 3.74512 10.368 3.74512 12C3.74512 13.632 4.22914 15.2273 5.13596 16.5842C6.04278 17.941 7.33165 18.9984 8.83953 19.6227C10.3474 20.2469 12.0066 20.4099 13.6071 20.091C15.2076 19.7721 16.6776 18.9857 17.8311 17.8313", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
